<template>
  <div class="content-item">
    <h2 class="heading">Great Job!! You Completed the Steps for Your Church!</h2>
    <p class="text">
      Now please join us in praying for your churches success! We are excited to see sow more seeds than they ever have before! Always remember.... Don't gather God's farmers on Sunday without giving
      them seeds to sow with on Monday
    </p>
    <div class="reset-button">
      <button key="reset" @click="handleReset">Reset Steps</button>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import UserService from '@/services/UserService';
export default {
  name: 'Step9',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    async handleReset() {
      let res = await UserService.updateActionStep({ step: 0 });
      if (res.action_box_step === 0) {
        window.location.reload();
      }
    },
  },
};
</script>
<style lang="scss">
.reset-button {
  width: 100%;
  text-align: center;
  button {
    background: #338dd7;
    width: 120px;
    padding: 5px;
    border: none;
    color: white;
  }
  button:hover {
    background: #1b55e3;
  }
}
</style>
